import { useMemo } from 'react'

import { Locale } from 'date-fns'

import { TourTime, ListingLocation } from '@app/models'
import { getTourTime } from '@app/utils'

export const useTourInfo = (
  tourTime: TourTime[] | undefined,
  location: ListingLocation | undefined,
  locale: Locale
) => {
  const timeFormat = 'HH:mm:ss'

  const getListingAddressLine1 = (location: ListingLocation | undefined) => {
    if (!location) {
      return null
    }

    return location.address1 || location.address2
  }

  const getListingAddressLine2 = (location: ListingLocation | undefined) => {
    if (!location) {
      return null
    }

    const address = []
    if (location.city) {
      address.push(location.city)
    }

    if (location.postcode) {
      address.push(location.postcode)
    }

    return address.join(', ')
  }

  const listingAddressLine1 = useMemo(() => {
    return getListingAddressLine1(location)
  }, [location])

  const listingAddressLine2 = useMemo(() => {
    return getListingAddressLine2(location)
  }, [location])

  const tourTimeFormatted = useMemo(() => {
    return getTourTime(timeFormat, locale, tourTime)
  }, [tourTime, locale])
  return {
    tourTimeFormatted,
    listingAddressLine1,
    listingAddressLine2,
  }
}
